import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-portal-user-signature',
  templateUrl: './portal-user-signature.component.html',
  styleUrls: ['./portal-user-signature.component.css']
})
export class PortalUserSignatureComponent implements OnInit {
    portalUserKeyno;

    public edit?: Edit;

    public readyEmailSignature = true;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.portalUserKeyno = this.stateService.getStateParams()['portal_user_keyno'];
    }

    private async loadEdit() {
        if (!!this.portalUserKeyno) {
            this.edit = (await this.datatask.Post(975, { portal_user_keyno: this.portalUserKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            await this.datatask.Post(976, this.edit);

            this.stateService.back();
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    portal_user_keyno: string;
    user_name: string;
    email_signature: string;
}
